export default __webpack_public_path__ + "static/media/startCol1.1494e670.jpg";